import React from 'react';

const Toplist = () => {
  return <h1>Toplist Page</h1>;
};

export default Toplist;
